import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Question} from 'shared/models/questions/question';
import {QuestionType} from 'shared/models/questions/question-type';
import {QuestionTypeFactoryService} from 'shared/questions/services/question-type-factory.service';
import {IQuestionsDetailsRepository} from './../repositories/questions-details.repository.interface';

@Injectable()
export class QuestionsDetailsService {

  constructor(@Inject('IQuestionsDetailsRepository') private questionsDetailsRepository: IQuestionsDetailsRepository,
              private questionTypeFactoryService: QuestionTypeFactoryService) { }

  public getQuestion(id: string): Observable<Question> {
    return this.questionsDetailsRepository.getQuestion(id)
      .map((question: Question) => {
        const questionType: QuestionType = this.questionTypeFactoryService
          .createQuestionType(question.type.name, question.type);
        question.type = questionType;

        return question;
      });
  }

  public saveQuestion(question: Question): Observable<Question> {
    return this.questionsDetailsRepository.saveQuestion(question);
  }

  public updateQuestion(question: Question): Observable<Question> {
    return this.questionsDetailsRepository.updateQuestion(question);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/services/questions-details.service.ts